<template>
    <div class="navigation">
        <div class="mainLinks">
            <router-link to="/support" class="full communication"><span class="icon"></span>{{'components/settings/navigation-mobile.communication' | trans}}</router-link>
            <router-link to="/settings/payment-methods" class="full payment"><span class="icon"></span>{{'components/settings/navigation-mobile.payment-methods' | trans}}</router-link>
            <router-link to="/settings/address-book" class="full address"><span class="icon"></span>{{'components/settings/navigation-mobile.address-settings' | trans}}</router-link>
            <router-link to="/settings/documents" class="full doc"><span class="icon"></span>{{'components/settings/navigation-mobile.documents' | trans}}</router-link>
            <router-link to="/faq" class="full faq" v-if="locale == 'en'"><span class="icon"></span>{{'pages/faq.menu-title' | trans }}</router-link>
        </div>
        <router-link to="" class=" full logout"><span class="icon"></span>{{'components/settings/navigation-mobile.logout' | trans}}</router-link>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                locale: window.lang.getLocale(),
            }
        }
    }
</script>

